import { Link } from 'react-router-dom';
import { Shield, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo">
              <div className="w-10 h-10 bg-mint-green/10 rounded-xl flex items-center justify-center border-2 border-mint-green/20">
                <span className="text-xl">🏝️</span>
              </div>
              <span className="font-display text-2xl tracking-wider">
                <span className="text-mint-green">Type</span>
                <span className="text-coral-orange">Town</span>
              </span>
            </Link>
            <p className="text-text-medium font-body text-sm max-w-md">
              TYPE. BUILD. LEARN. A typing adventure for children aged 5-11, 
              designed to help those who struggle with handwriting.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-lg text-coral-orange mb-4">For You</h4>
            <ul className="space-y-2">
              <li><Link to="/for-schools" className="text-text-medium hover:text-mint-green text-sm">For Schools</Link></li>
              <li><Link to="/for-pupils" className="text-text-medium hover:text-mint-green text-sm">For Pupils</Link></li>
              <li><Link to="/for-parents" className="text-text-medium hover:text-mint-green text-sm">For Parents</Link></li>
              <li><Link to="/pricing" className="text-text-medium hover:text-mint-green text-sm">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-coral-orange mb-4">Support</h4>
            <ul className="space-y-2">
              <li><a href="mailto:clare@bluecactus.digital" className="text-text-medium hover:text-mint-green text-sm flex items-center gap-2"><Mail className="w-4 h-4" /> Contact</a></li>
              <li><Link to="/privacy" className="text-text-medium hover:text-mint-green text-sm flex items-center gap-2"><Shield className="w-4 h-4" /> Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-text-medium/60 text-sm">
            © 2026 TypeTown by Blue Cactus Digital. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-text-medium/60 text-xs flex items-center gap-1"><Shield className="w-3 h-3" /> GDPR Compliant</span>
            <span className="text-text-medium/60 text-xs">COPPA Compliant</span>
            <span className="text-text-medium/60 text-xs">No Ads</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
